<template>
  <div
    id="Booking"
    @click="hideEle">
    <div class="header pr">
      <div class="new_booking">
        <Output :ProgramItem="ProgramItem" from="pushStatus"/>
        <epg-interval-hint></epg-interval-hint>
        <div
          class="duplicate"
          type="text"
          @click="duplicate">
          <i class="el-icon-document-copy" :disabled="CloneDisabled.disableButton"></i>
          {{ $t("lang.duplicate") }}
        </div>
          <el-select v-model="eventModeType" @change="changeSchedulerModes" >
            <el-option
              v-for="item in eventModesList"
              :key="item.type"
              :label="$t('lang.'+item.name)"
              :value="item.type"
              >
            </el-option>
          </el-select>
        <!-- <div
          class="uploadBtn"
          @click="ExportEPG"
          type="text">Export EPG XML</div> -->
      </div>
    </div>
    <div class="content" id="ContentCalendarBox">
      <calendar
        :calendar="isShow.calendar"
        :bookmark="bookmark"
        @nextAdd="nextAdd"></calendar>
    </div>
    <!-- 复制弹出框//h -->
    <duplicate v-if="isShow.duplicate" :dialogVisible.sync="isShow.duplicate"> </duplicate>
  </div>
</template>
<script>
import calendar from './calendarModule'
import Outil from '../../assets/js/utils.js'
import { mapState } from 'vuex'
import duplicate from './duplicate'
import toTips from '@/assets/js/toTipsObj'
import { scheduleAnalyze } from '../../assets/js/googleAnalyze/playout.js'
import EpgIntervalHint from '@/components/common/EpgIntervalHint.vue'
import Bus from '@/assets/js/vueBus.js'
import Output from '@/views/Workbench/Output.vue'
export default {
  data () {
    return {
      scteVisible: false,
      pendingEvent: false,
      event: {}, // 创建/编辑框内的数据
      fromCreateBooking: false,
      // 时间段复制事件
      isShow: {
        duplicate: false
      },
      bookmark: [],
      // CrawlSingular的开关
      OverlaySwitch: false,
      eventModesList: [{ name: 'playoutDisplayMode', type: 'calendar' }, { name: 'eventDisplayMode', type: 'list' }],
      eventModeType: 'calendar',
      ProgramItem: null
    }
  },
  components: {
    calendar,
    duplicate,
    EpgIntervalHint,
    Output
  },
  created () {
    const channelInitConfig = localStorage.getItem('channelInitConfig') && JSON.parse(localStorage.getItem('channelInitConfig'))
    const programTabPrefix = channelInitConfig && channelInitConfig.urlInfo.programTabPrefix
    this.ProgramItem = Outil.getProgramReceiver()
    // 建立行为同步的websocket
    if (this.BehaviorWebsocket) {
      this.$BehaviorSyns.BehaviorWebsocket('off')
      this.$BehaviorSyns.BehaviorWebsocket('init', programTabPrefix.scheduleTabPrefix)
    } else {
      this.$BehaviorSyns.BehaviorWebsocket('init', programTabPrefix.scheduleTabPrefix)
    }
    this.$store.commit('playout/CloneDisabled')
  },
  mounted () {
  },
  computed: mapState({
    State: (state) => state,
    pageRequest: (state) => state.websocket.pageRequest,
    pageRWebsocket: (state) => state.websocket.pageRWebsocket,
    // 行为同步websocket
    BehaviorWebsocket: (state) => state.websocket.BehaviorWebsocket,
    CloneDisabled: (state) => state.playout.CloneDisabled
  }),
  methods: {
    nextAdd (data) {
      // if(data){
      this.templateName = data
      // }
    },
    // 导出24的event
    ExportEPG () {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/EPG/url'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        console.log(res)
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const objectUrl = res.data.result
            const download = document.createElement('a')
            download.href = objectUrl
            download.click()
            download.remove()
          }
        } else {
          const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 复制功能
    duplicate () {
      if (this.CloneDisabled.disableButton) return
      scheduleAnalyze('schedulerDuplicate', '/po')
      this.isShow.duplicate = true
    },
    // 隐藏元素
    hideEle () {
      for (var key in this.isShow.calendar) {
        this.isShow.calendar[key] = false
      }
    },
    // 获取bookmark
    getBookmarkAll () {
      Outil.axios('post', '/gatewayPlayoutUrl/tvu-playout/extra/getAllChildBookmarkTree', '',
        (data) => {
          data.push({
            bookmarkName: 'lang.unClassified',
            children: [],
            id: 'unclassified'
          })
          this.bookmark = data
        }
      )
    },
    // 切换event展示模式
    changeSchedulerModes () {
      const calendar_box = document.getElementsByClassName('calendar_box')[0]
      if (calendar_box && calendar_box.style && calendar_box.style.display == 'none') {
        this.$message.info(this.$t('lang.CalendarModeLimit'))
        if (this.eventModeType == 'calendar') {
          this.eventModeType = 'list'
        } else {
          this.eventModeType = 'calendar'
        }
        return
      }
      Bus.$emit('changeSchedulerModes', this.eventModeType)
    }
  },
  beforeDestroy () {
  }
}
</script>
<style lang="less" scoped>
#Booking {
  height: 100%;
  background: #444;
  input,
  textarea {
    outline: none;
  }
  p {
    margin-bottom: 0;
  }
  .header {
    height: 60px;
    background: #252525;
    z-index: 1998;
    .f_left,
    .f_right {
      height: 100%;
    }
    .table_view {
      height: 100%;
      text-align: left;
      margin-left: 34px;
      // width: 274px;
      // width: 360px;
      width: 490px;
      font-size: 24px;
      .templateName {
        height: 100%;
        line-height: 3;
        font-size: 20px;
        span {
          margin-left: 10px;
        }
        // .el-icon-arrow-down:nth-child(1){
        //      margin-left:10px;
        // }
      }
      p {
        height: 100%;
        padding-top: 18px;
        text-align: center;
        width: 100px;
      }
      p {
        margin-right: 30px;
      }
      p:last-child {
        margin-right: 0;
      }
      p.active {
        border-bottom: 4px solid #33ab4f;
        color: #fff;
      }
      .scte_box {
        padding-top: 13px;
      }
      .scte {
        display: inline-block;
        border: 1px solid #ccc;
        font-size: 12px;
        width: 38px;
        height: 23px;
        line-height: 23px;
        padding: 0;
        border-radius: 5px;
      }
    }
    .booking_execute {
      font-size: 10px;
      line-height: 60px;
      padding-left: 15px;
      z-index: 3036;
      .circle {
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: #33ab4f;
        left: 0;
      }
      .booking_exe_info {
        z-index: 3036;
        width: 400px;
        text-align: left;
        .more {
          position: absolute;
          right: 0;
          top: 55%;
          transform: translateY(-50%);
          border-width: 8px;
        }
      }
      button:hover {
        background-color: rgba(216, 216, 216, 0.2);
      }
      button {
        width: 100px;
        height: 26px;
        background: rgba(216, 216, 216, 0);
        line-height: 26px;
        border-radius: 4px;
        border: 1px solid #757575;
        text-align: center;
        margin-top: 17px;
        margin-left: 20px;
        cursor: pointer;
      }
      .runnings_info {
        width: 100%;
        position: absolute;
        left: -6px;
        top: 40px;
        background: #666;
        border-radius: 4px;
        z-index: 100;
        li {
          height: 25px;
          line-height: 25px;
          padding-left: 10px;
          padding-right: 5px;
          cursor: pointer;
        }
        li:hover {
          background: rgba(0, 208, 105, 0.2);
        }
      }
    }
    .new_booking {
      height: 100%;
      margin-right: 80px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .Crawl {
        height: 26px;
        line-height: 26px;
        border-radius: 2px;
        border: 1px solid #666666;
        color: #dfdfdf;
        margin-right: 40px;
        padding: 0 10px;
      }
      .duplicate {
        width: 101px;
        height: 26px;
        line-height: 26px;
        border-radius: 2px;
        border: 1px solid #666666;
        font-size: 14px;
        color: #dfdfdf;
        margin-right: 16px;
      }
      ::v-deep  .el-select{
        padding-left: 20px;
          input{
            border: none;
            background:#252525 ;
          }
          .el-input__suffix{
            right: 20px;
          }
      }
      .uploadBtn {
        width: 149px;
        height: 26px;
        line-height: 26px;
        border-radius: 2px;
        border: 1px solid #666666;
        font-size: 14px;
        color: #dfdfdf;
      }
      p {
        width: 100px;
        height: 36px;
        line-height: 36px;
        font-size: 16px;
      }
      .copy {
        color: #33ab4f;
        border: 1px solid #33ab4f;
        border-radius: 6px;
        background-color: rgba(49, 171, 79, 0);
        margin-right: 14px;
      }
      .dis_copy.copy {
        background: linear-gradient(180deg, #575757, #444);
        border-color: #444;
        color: #999;
      }
      .copy:hover {
        background-color: rgba(49, 171, 79, 0.2);
      }
      .el-button.el-button--text {
        background: #33ab4f;
        color: #fff;
        // padding: 6px 12px;
        font-size: 16px;
        height: 36px;
        line-height: 36px;
        padding: 0 25px;
      }
    }
  }
  .content {
    background: #444;
    min-height: 850px;
    height: calc(100% - 60px);
  }
  .create {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #666;
    opacity: 0.65;
    z-index: 100;
  }
}
::v-deep .el-popper[x-placement^='bottom'] .popper__arrow:after {
  border-bottom-color: #fff;
}
::v-deep .table_view .filter .el-input__inner {
  cursor: pointer;
}
::v-deep .el-input.el-input--small .el-input__inner {
  background: #fff;
  border-color: #e4e4e4;
}
::v-deep .el-date-picker__editor-wrap .el-input.el-input--small .el-input__inner {
  color: #000;
}
::v-deep .el-message {
  z-index: 30000 !important;
}
// ::v-deep .el-dialog__wrapper {
//     z-index: 2038!important;
// }
@media (min-width: 500px) and (max-width: 759px) {
  #Booking {
    .content {
      clear: both;
    }
    .header {
      .new_booking {
        margin-right: 10px;
        padding-top: 16px;
        margin-top: 0px;
      }
      .table_view {
        margin-left: 10px;
        width: 189px;
        p {
          width: 65px;
          &:first-child {
            margin-right: 5px;
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  #Booking .header .table_view {
    margin-left: -5px;
  }
}
</style>

<style lang="less">
.el-picker-panel.el-date-picker.el-popper.pick_date_time {
  z-index: 2039 !important;
}
</style>
